"use strict";
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.css = exports.props = void 0;
var withCompInfo_1 = require("../../core/withCompInfo");
var parseCss_1 = require("./parseCss");
var isHorizontallyDocked = function (layout) { var _a, _b; return !!(((_a = layout.docked) === null || _a === void 0 ? void 0 : _a.right) && ((_b = layout.docked) === null || _b === void 0 ? void 0 : _b.left)); };
var getPositionBoxMargin = function (margin, mainMenuStretched, subMenuStretched) {
    var subMenuHasMargins = Boolean(margin);
    if (subMenuStretched) {
        // it submenu is stretched, it should be stretched to 100%, but may have own margins
        if (subMenuHasMargins) {
            return "calc(100% - " + 2 * margin + "px)";
        }
        return '100%';
    }
    if (!mainMenuStretched && !subMenuStretched) {
        return '100%'; // if both menu & submenu are not stretched, submenu should fill menu width
    }
    return '980px'; // if submenu is not stretched, it should be contained inside page width
};
exports.props = withCompInfo_1.withCompInfo(['compProps', 'compLayout', 'compStylableClass', 'styleProperties'], function (_a, carmiProps) {
    var compProps = _a.compProps, compLayout = _a.compLayout, compStylableClass = _a.compStylableClass, styleProperties = _a.styleProperties;
    var menuMode = compProps.menuMode, submenuMode = compProps.submenuMode, submenuOrder = compProps.submenuOrder;
    var cssText = styleProperties['st-css'];
    return {
        menuMode: menuMode,
        submenuMode: submenuMode,
        submenuOrder: submenuOrder,
        items: carmiProps.items,
        isStretched: isHorizontallyDocked(compLayout),
        className: compStylableClass,
        currentPageHref: '',
        direction: parseCss_1.parseDirection(cssText),
        flyoutAlignment: parseCss_1.parseFlyoutAlignment(cssText),
    };
});
exports.css = withCompInfo_1.withCompInfo(['compProps', 'styleProperties', 'compLayout'], function (_a) {
    var _b;
    var _c = _a.compProps, menuMode = _c.menuMode, submenuMode = _c.submenuMode, submenuOrder = _c.submenuOrder, styleProperties = _a.styleProperties, compLayout = _a.compLayout;
    var cssText = styleProperties['st-css'];
    var isRTL = parseCss_1.parseDirection(cssText) === 'rtl';
    var isScrollable = menuMode === 'scroll';
    var isFlyout = submenuMode === 'flyout';
    var isMainMenuStretched = isHorizontallyDocked(compLayout);
    var isSubmenuStretched = submenuMode === 'columnStretched';
    var subMenuMarginLeft = parseCss_1.parseValueFromCss(cssText, 'positionBox', 'margin-left', 0);
    var subMenuMarginBottom = parseCss_1.parseValueFromCss(cssText, 'columnsLayout::menuItem', 'margin-bottom', 0);
    return __assign({ '--white-space': isFlyout ? 'nowrap' : 'normal', '--label-word-wrap': isFlyout ? 'normal' : 'break-word', '--menu-flex-wrap': isScrollable ? 'nowrap' : 'wrap', '--submenu-box-position': isFlyout ? 'fixed' : 'absolute', '--submenu-box-margin-top': isFlyout || isScrollable
            ? 0
            : -1 * parseCss_1.parseValueFromCss(cssText, 'menuItem', 'margin-bottom', 0), '--columns-display': !isFlyout && submenuOrder === 'horizontal' ? 'grid' : 'block', '--submenu-width': isFlyout
            ? 100
            : parseCss_1.parseValueFromCss(cssText, 'columnsLayout::listWrapper', 'width', 100), '--submenu-margin-bottom': subMenuMarginBottom, '--subsubmenu-margin-bottom': isFlyout ? subMenuMarginBottom : 0, '--subsubmenu-box-opacity': isFlyout ? 0 : 1, '--subsubmenu-box-pointer-events': isFlyout ? 'none' : 'inherit', '--subsubmenu-box-position': isFlyout ? 'absolute' : 'static', '--subsubmenu-box-show-animation': isFlyout ? 1 : 0, '--subsubmenu-box-left': isRTL ? 'unset' : '100%', '--subsubmenu-box-right': isRTL ? '100%' : 'unset', '--subsubmenu-box-translate-x-coef': isRTL ? 1 : -1 }, (!isFlyout && (_b = {
            '--submenu-box-width': getPositionBoxMargin(subMenuMarginLeft, isMainMenuStretched, isSubmenuStretched),
            '--submenu-box-left': 0,
            '--submenu-box-right': 0,
            '--submenu-box-margin': isSubmenuStretched
                ? subMenuMarginLeft + "px"
                : 'auto',
            '--columns-count': parseCss_1.parseValueFromCss(cssText, 'columnsLayout::listWrapper', '--columnsAmount', 3),
            '--submenu-justify-content': parseCss_1.parseValueFromCss(cssText, 'columnsLayout::pageWrapper', 'justify-content', 'flex-start'),
            '--horizontal-spacing': parseCss_1.parseValueFromCss(cssText, 'columnsLayout', '--horizontalSpacing', 0)
        },
        _b[submenuOrder === 'horizontal'
            ? '--vertical-spacing'
            : '--category-spacing'] = -parseCss_1.parseValueFromCss(cssText, 'columnsLayout::flex', 'margin-bottom', 0),
        _b)));
});
//# sourceMappingURL=StylableHorizontalMenu.js.map